import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/(commerce)/giris-yap/page.tsx");
